import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { BRAND, GRAY, ACCENT } from "../colors";

const BARS = [
  { label: "Mon", value: 0.6 },
  { label: "Tue", value: 0.8 },
  { label: "Wed", value: 0.45 },
  { label: "Thu", value: 0.9 },
  { label: "Fri", value: 0.7 },
  { label: "Sat", value: 1.0 },
  { label: "Sun", value: 0.55 },
];

export const DashboardAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const panelAppear = spring({ frame, fps, config: { damping: 14 } });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: GRAY[50],
        padding: 36,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          transform: `scale(${panelAppear})`,
          opacity: panelAppear,
          width: "100%",
          maxWidth: 600,
          backgroundColor: "white",
          borderRadius: 20,
          padding: 32,
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 24 }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: GRAY[800] }}>Review Analytics</div>
          <div style={{ fontSize: 16, color: GRAY[400] }}>Last 7 days</div>
        </div>

        {/* Metric cards */}
        <div style={{ display: "flex", gap: 14, marginBottom: 28 }}>
          {[
            {
              label: "Response Rate",
              value: 94,
              suffix: "%",
              color: ACCENT[500],
              delay: 20,
            },
            {
              label: "Avg Reply Time",
              value: 12,
              suffix: "min",
              color: BRAND[500],
              delay: 30,
            },
            {
              label: "New Reviews",
              value: 23,
              suffix: "",
              color: "#F59E0B",
              delay: 40,
            },
          ].map((m) => {
            const counter = interpolate(frame, [m.delay, m.delay + 40], [0, m.value], {
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp",
            });
            return (
              <div
                key={m.label}
                style={{
                  flex: 1,
                  backgroundColor: GRAY[50],
                  borderRadius: 14,
                  padding: "16px 18px",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: 32, fontWeight: 800, color: m.color }}>
                  {Math.round(counter)}
                  <span style={{ fontSize: 18 }}>{m.suffix}</span>
                </div>
                <div style={{ fontSize: 14, color: GRAY[400], marginTop: 4 }}>{m.label}</div>
              </div>
            );
          })}
        </div>

        {/* Bar chart */}
        <div>
          <div style={{ fontSize: 17, fontWeight: 600, color: GRAY[600], marginBottom: 16 }}>
            Reviews per day
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              gap: 10,
              height: 110,
            }}
          >
            {BARS.map((bar, i) => {
              const barHeight = spring({
                frame: frame - 25 - i * 5,
                fps,
                config: { damping: 12, stiffness: 80 },
              });
              return (
                <div
                  key={bar.label}
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: bar.value * 90 * barHeight,
                      borderRadius: 6,
                      background: `linear-gradient(to top, ${BRAND[500]}, ${BRAND[300]})`,
                      minHeight: 2,
                    }}
                  />
                  <div style={{ fontSize: 13, color: GRAY[400] }}>{bar.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
};
